module.exports = __webpack_public_path__ + "img/26.a6ef7072.jpg";